export enum ProductCondition {
    New = 'neu',
    Used = 'gebraucht',
}
